import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReactComponent as ChallengeIcon } from '../../../Assets/Icons/challenge.svg';
import { ReactComponent as GoalIcon } from '../../../Assets/Icons/goals.svg';
import { ReactComponent as HomeIcon } from '../../../Assets/Icons/home.svg';
import { ReactComponent as InnovationIcon } from '../../../Assets/Icons/innovation.svg';
import { ReactComponent as MentorIcon } from '../../../Assets/Icons/mentor.svg';
import { ReactComponent as NetworkIcon } from '../../../Assets/Icons/network.svg';
import { ReactComponent as ParticipateIcon } from '../../../Assets/Icons/participate.svg';
import { ReactComponent as PeopleIcon } from '../../../Assets/Icons/people.svg';
import { ReactComponent as ProgramIcon } from '../../../Assets/Icons/programs.svg';
import KenColors from '../../../Helpers/Themes/kenColors';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';

import GroupsIcon from '@mui/icons-material/Groups';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  hideSideBar: boolean;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, hideSideBar }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const [openMenus, setOpenMenus] = useState<{ [key: string]: boolean }>({});

  const handleMenuClick = (menuName: string) => {
    setOpenMenus((prevState) => ({
      ...prevState,
      [menuName]: !prevState[menuName], // Toggle the clicked menu
    }));
  };

  const sideNavContents = [
    {
      icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => <GoalIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Goals & Milestones',
      link: routes.goalsAndMilestones,
      name: 'Goals & Milestones',
    },
    {
      icon: (isActive: boolean) => <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Events',
      link: routes.events,
      name: 'Events',
    },
    {
      icon: (isActive: boolean) => <ParticipateIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Participate',
      link: routes.program,
      name: 'Participate',
      // nested: true,
      // nestedItems: [
      //   {
      //     icon: (isActive: boolean) => <ProgramIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      //     name: 'Programs',
      //     label: 'Programs',
      //     link: routes.program,
      //   },
      //   // {
      //   //   icon: (isActive: boolean) => <ChallengeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      //   //   name: 'Challenges',
      //   //   label: 'Challenges',
      //   //   link: routes.challenges,
      //   // },
      // ],
    },

    {
      icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Community',
      link: routes.startups,
      name: 'Community',
      // nested: true,
      // nestedItems: [
      //   // {
      //   //   icon: (isActive: boolean) => <PeopleIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      //   //   name: 'People',
      //   //   label: 'People',
      //   //   link: routes.people,
      //   // },
      //   {
      //     icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      //     name: 'Startups',
      //     label: 'Startups',
      //     link: routes.startups,
      //   },
      //   // {
      //   //   icon: (isActive: boolean) => <GroupsIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      //   //   name: 'Groups',
      //   //   label: 'Groups',
      //   //   link: routes.groups,
      //   // },
      // ],
    },
    {
      icon: (isActive: boolean) => <MentorIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Mentors',
      link: routes.mentors,
      name: 'Mentors',
    },
    {
      icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      name: 'Resources &  Offers',
      label: 'Resources &  Offers',
      link: routes.deals,
    },
    {
      icon: (isActive: boolean) => <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      name: 'Services & Support',
      label: 'Services & Support',
      link: routes.support,
    },
    

    // {
    //   icon: (isActive: boolean) => <InnovationIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
    //   label: 'Innovation Center',
    //   link: '#',
    //   name: 'Innovation Center',
    //   nested: true,
    //   nestedItems: [
    //     {
    //       icon: (isActive: boolean) => <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
    //       name: 'Resources &  Offers',
    //       label: 'Resources &  Offers',
    //       link: routes.deals,
    //     },
    //     {
    //       icon: (isActive: boolean) => <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
    //       name: 'Services & Support',
    //       label: 'Services & Support',
    //       link: routes.support,
    //     },
    //   ],
    // },
  ].filter(Boolean); // This will remove false and undefined values from the array

  const isActive = (link: string) => pathname?.startsWith(link);
  const isAnyNestedItemActive = (nestedItems: any[]) => {
    return nestedItems.some((nestedItem) => isActive(nestedItem.link));
  };

  return (
    <>
      {sideNavContents.map((items:any, index) => {
        if (items?.nested) {
          const anyNestedItemActive = isAnyNestedItemActive(items.nestedItems);
          const isMenuOpen = openMenus[items.name] || false;

          return (
            <div key={index}>
              <ListItemButton
                onClick={() => handleMenuClick(items.name)}
                sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
                className={`${classes.listItemButton} ${anyNestedItemActive && classes.nestedlistItemButtonActive}`}
              >
                <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(isMenuOpen)}</ListItemIcon>
                {!hideSideBar && (
                  <>
                    <ListItemText className={`${classes.listItemText} ${anyNestedItemActive && classes.listItemTextActive}`} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
                      {items.label}
                    </ListItemText>
                    {isMenuOpen ? <ExpandLess sx={{ color: KenColors.kenWhite }} /> : <ExpandMore sx={{ color: KenColors.kenWhite }} />}
                  </>
                )}
              </ListItemButton>
              <Collapse in={isMenuOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {items.nestedItems.map((nestedItem: any, nestedIndex: any) => (
                    <ListItemButton
                      key={nestedIndex}
                      onClick={() => handleListClick(nestedItem.link, nestedIndex)}
                      className={`${classes.listItemButton} ${isActive(nestedItem.link) && classes.listItemButtonActive}`}
                    >
                      <Box sx={{ ml: hideSideBar ? 0 : 1.5, display: 'flex', alignItems: 'center' }}>
                        <ListItemIcon sx={{ minWidth: '40px' }}>{nestedItem.icon(isActive(nestedItem.link))}</ListItemIcon>
                        {!hideSideBar && (
                          <ListItemText
                            primary={nestedItem.label}
                            className={`${classes.listItemText} ${isActive(nestedItem.link) && classes.listItemTextActive}`}
                            sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}
                          />
                        )}
                      </Box>
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </div>
          );
        } else {
          return (
            <ListItemButton
              key={index}
              onClick={() => handleListClick(items.link, index)}
              sx={{ marginTop: index === 0 ? { xs: '10px', sm: '15px', md: '25px', lg: '35px' } : '12px' }}
              className={`${classes.listItemButton} ${isActive(items.link) && classes.listItemButtonActive}`}
            >
              <ListItemIcon sx={{ minWidth: '40px' }}>{items.icon(isActive(items.link))}</ListItemIcon>
              {!hideSideBar && (
                <ListItemText className={`${classes.listItemText} ${isActive(items.link) && classes.listItemTextActive}`} sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' } }}>
                  {items.label}
                </ListItemText>
              )}
            </ListItemButton>
          );
        }
      })}
    </>
  );
};

export default SideNavTabs;
